import { LeftArrowIcon, RedirectIcon } from "@dataone/icons";
import { ISearchPayload, isEmpty, useAppLayout } from "@dataone/lib";
import { styled } from "styled-components";
import { useSmartSearch } from "../../../../../contexts/smart-search.provider";

interface InvalidInputMessageProps {
  message: string;
  suggestions: string[];
  setSelectedSearch: React.Dispatch<React.SetStateAction<{ message: string }>>;
  setResponse: React.Dispatch<React.SetStateAction<Partial<ISearchPayload>>>;
}

function InvalidInputMessage({
  message,
  suggestions,
  setSelectedSearch,
  setResponse,
}: InvalidInputMessageProps) {
  const { setShowResponse, setSearchMessageError, setSearchSuggestionsError } =
    useSmartSearch();
  const { isSmartSearchVisible } = useAppLayout();

  const showSmartSearch = () => {
    useAppLayout.setState({ isSmartSearchVisible: true });
  };

  const hideResponse = () => {
    if (isSmartSearchVisible) {
      useAppLayout.setState({ isResponseVisible: false });
      setShowResponse(false);
      setResponse((prev) => ({ ...prev, id: undefined }));
      setSearchMessageError("");
      setSearchSuggestionsError([]);
    } else showSmartSearch();
  };

  return (
    <StyledContent>
      <StyledTitle>
        <div className="icon">
          <RedirectIcon />
        </div>{" "}
        <div className="title">Sorry i'm kinda lost</div>
        <StyledReset onClick={hideResponse}>
          <StyledLeftArrowIcon>
            <LeftArrowIcon />
          </StyledLeftArrowIcon>
          <div className="reset">START A NEW SEARCH</div>
        </StyledReset>
      </StyledTitle>

      {isEmpty(suggestions) ? (
        <StyledDescription>{message}</StyledDescription>
      ) : (
        <StyledDescriptionSuggestions>
          <p>{message}</p>
          <ul>
            {suggestions.map((suggestion) => (
              <li
                key={suggestion}
                onClick={() => setSelectedSearch({ message: suggestion })}
              >
                {suggestion}
              </li>
            ))}
          </ul>
        </StyledDescriptionSuggestions>
      )}
    </StyledContent>
  );
}

export default InvalidInputMessage;

const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: #040726;
  font-size: 15px;
  font-weight: 400;
  letter-spacing: -0.285px;
  padding: 5px 5px 10px 5px;
  .title {
    margin-left: 10px;
  }
  .icon {
    color: #4974f6;
    display: flex;
    font-size: 20px;
  }
`;

const StyledDescription = styled.div`
  padding: 10px 20px;
  border-radius: 15px;
  background: #f9ebee;
  color: #040726;
  font-size: 15px;
  font-weight: 400;
  line-height: 40px;
  letter-spacing: -0.3px;
  font-size: 13px;
`;

const StyledDescriptionSuggestions = styled.div`
  padding: 10px 20px;
  border-radius: 15px;
  background: #eff1fd;
  color: #040726;
  font-size: 15px;
  font-weight: 400;
  line-height: 40px;
  letter-spacing: -0.3px;
  font-size: 13px;

  p {
    margin-top: 0;
  }

  li {
    list-style: none;
    color: #4974f6;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
`;

const StyledLeftArrowIcon = styled.div`
  display: flex;
  font-size: 25px;
  color: #4974f6;
  border: 1.5px solid #4974f6;
  border-radius: 20px;
  margin-right: 5px;
  position: absolute;
  width: 28px;
  transition: width 0.5s ease-in-out;
  svg {
    transform: rotate(180deg);
  }
`;
const StyledReset = styled.div`
  margin-left: auto;
  font-size: 14px;
  display: flex;
  align-items: center;
  border-radius: 20px;
  cursor: pointer;
  width: 180px;
  position: relative;
  &:hover {
    ${StyledLeftArrowIcon} {
      width: 183px;
      transition: width 0.5s ease-in-out;
    }
  }

  .reset {
    margin-left: 33px;
  }
`;
